module.exports = __webpack_public_path__ + "static/1-8872de9cba4baf87dfbf85fb3b109633.jpg";